import React, { useState } from "react";
import { colorBlue, colorLightBlue } from "../../../../../../utils/palette";
import { useTranslation } from "react-i18next";
import defaultPartIcon from "@/shared/img/default/default_parts.png";
import { useSelector } from "react-redux";
import { s3Url } from "../../../../../constants";
import { LinkSpan } from "../../../../form/FormElements";
import AssetsPopup from "../../../../../../components/Inventory/components/AssetsPopup";
import { formatNumber } from "../../../../../helpers";

const PartInfoComponent = ({ rowData }) => {
  console.log("rowData in PartInfoComponent", rowData);
  const { t } = useTranslation("common");
  const { orgId } = useSelector((state) => state.user);
  const {
    part_name,
    part_number,
    qty,
    isParent,
    warehouse_loc,
    part_notes,
    part_img,
    part_id,
    barcode,
    veh_ids,
  } = rowData;
  const partImg = part_img
    ? `${s3Url}/org_${orgId}/parts/${part_id}/${part_img}`
    : "";

  const [showAssetsPopup, setShowAssetsPopup] = useState(false);

  let locationQtyStr = "";
  // if (!isParent && !qty) {
  //   locationQtyStr = `${warehouse_loc || ""}`;
  // }
  if (isParent && qty) {
    locationQtyStr = `${t("available_qty")}: ${formatNumber(qty)}`;
  }
  if (!isParent && qty) {
    locationQtyStr += `${warehouse_loc} / ${t("available_qty")}: ${formatNumber(
      qty
    )}`;
  }

  const allVehicles = useSelector((state) => state.vehicles.list);
  const activeVehicles = allVehicles.filter((v) => v.veh_active === 1);

  let assignedVehicles = [];
  // if (veh_ids?.length) {
  //   assignedVehicles = allVehicles?.filter((v) => veh_ids.includes(v.veh_id));
  // }

  if (veh_ids) {
    const vehIdsArr = veh_ids.split(":::");
    const activeVehicleIds = activeVehicles.map((v) => v.veh_id);
    for (let id of vehIdsArr) {
      if (activeVehicleIds.includes(id)) {
        const vehicle = activeVehicles.find((v) => v.veh_id === id);
        assignedVehicles.push(vehicle);
      } else {
        assignedVehicles.push({
          value: id,
          veh_id: id,
          label: t("unassigned_asset"),
          name: t("unassigned_asset"),
          veh_img: "",
        });
      }
    }
  }

  return (
    <>
      {showAssetsPopup && (
        <AssetsPopup
          showPopup={showAssetsPopup}
          setShowPopup={setShowAssetsPopup}
          vehicles={assignedVehicles}
        />
      )}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2 align-items-center py-2">
          <div
            style={{
              border: `1px solid ${colorBlue}`,
              borderRadius: "20px",
              width: 40,
              height: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={partImg || defaultPartIcon}
              alt="part-img"
              style={{ width: "40px", height: "40px" }}
              className="rounded-circle"
            />
          </div>
          <div
            style={{ overflow: "auto" }}
            className="d-flex flex-column gap-1"
          >
            {/* <div className="d-flex align-items-center gap-1"> */}
            <p style={{ fontSize: "14px", fontWeight: 400 }}>{part_name}</p>
            {/* {part_number && (
              <p style={{ fontSize: "12px" }}>{`/ ${t(
                "part_no"
              )}: ${part_number}`}</p>
            )} */}

            {/* </div> */}
            {assignedVehicles.length > 0 && (
              <LinkSpan onClick={() => setShowAssetsPopup(true)}>
                {t("assigned_to_count_assets", {
                  count: assignedVehicles?.length,
                })}
              </LinkSpan>
            )}
            {/* <div className="d-flex align-items-center gap-1"> */}
            {/* {!isParent && <p style={{ fontSize: "12px" }}>{warehouse_loc}</p>} */}
            {/* {barcode && (
              <p style={{ fontSize: "12px" }}>{`${t(
                "upc_barcode"
                )}: ${barcode}`}</p>
                )} */}
            {/* <p style={{ fontSize: "12px" }}>{` / ${t("available_qty")}: ${
                qty || 0
              }`}</p> */}
            <p style={{ fontSize: "12px" }}>{locationQtyStr}</p>
            {/* </div> */}
          </div>
        </div>
      </div>
      <div>
        <p className="mb-1" style={{ fontSize: "12px" }}>
          {part_notes}
        </p>
      </div>
    </>
  );
};

export default PartInfoComponent;
